import { offlineDemoStorageKey } from 'src/features/offline-demo/boot';

export const DEVICE_CONTEXT_STORAGE_KEY = offlineDemoStorageKey('pointcraft-device-context');
